import { toast } from '@heroui/react';
import { onForegroundMessage } from './firebase-messaging';

let started = false;

/** Um único listener: toast no app em foco. Sem banner nativo extra. */
export function startForegroundPushToasts(): void {
  if (started) return;

  const unsubscribe = onForegroundMessage((payload) => {
    const title = payload.notification?.title || payload.data?.title || 'LinkPark';
    const body = payload.notification?.body || payload.data?.body || '';
    toast.info(title, { description: body });
  });

  if (unsubscribe) {
    started = true;
  }
}
